import type { ReactNode } from 'react';

import { paths } from '@/app/routes/paths';
import { RequirePermission } from '@/app/routes/RequirePermission';

/**
 * Staff capability: `participants.manage`. Others (e.g. guardians) go to the guardian dashboard.
 */
export function RequireParticipantsManage({ children }: { children: ReactNode }) {
  return (
    <RequirePermission permission="participants.manage" redirectTo={paths.guardianDashboard}>
      {children}
    </RequirePermission>
  );
}
